/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Segment,
    SegmentFromJSON,
    SegmentToJSON,
} from '../models/Segment';
import {
    type SegmentStatusLog,
    SegmentStatusLogFromJSON,
    SegmentStatusLogToJSON,
} from '../models/SegmentStatusLog';
import {
    type StatusRequest,
    StatusRequestFromJSON,
    StatusRequestToJSON,
} from '../models/StatusRequest';

export interface CreateSegmentRequest {
    segment: Segment;
}

export interface DeleteSegmentRequest {
    id: string;
}

export interface GetSegmentRequest {
    id: string;
}

export interface GetStatusLogsRequest {
    id: string;
}

export interface UpdateSegmentRequest {
    id: string;
    segment: Segment;
}

export interface UpdateStatusRequest {
    id: string;
    statusRequest: StatusRequest;
}

/**
 * 
 */
export class SegmentApi extends runtime.BaseAPI {

    /**
     * Creates request options for createSegment without sending the request
     */
    async createSegmentRequestOpts(requestParameters: CreateSegmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['segment'] == null) {
            throw new runtime.RequiredError(
                'segment',
                'Required parameter "segment" was null or undefined when calling createSegment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SegmentToJSON(requestParameters['segment']),
        };
    }

    /**
     */
    async createSegmentRaw(requestParameters: CreateSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Segment>> {
        const requestOptions = await this.createSegmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SegmentFromJSON(jsonValue));
    }

    /**
     */
    async createSegment(requestParameters: CreateSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Segment> {
        const response = await this.createSegmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteSegment without sending the request
     */
    async deleteSegmentRequestOpts(requestParameters: DeleteSegmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSegment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteSegmentRaw(requestParameters: DeleteSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteSegmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteSegment(requestParameters: DeleteSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSegmentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllSegments without sending the request
     */
    async getAllSegmentsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllSegmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Segment>>> {
        const requestOptions = await this.getAllSegmentsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SegmentFromJSON));
    }

    /**
     */
    async getAllSegments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Segment>> {
        const response = await this.getAllSegmentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSegment without sending the request
     */
    async getSegmentRequestOpts(requestParameters: GetSegmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSegment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSegmentRaw(requestParameters: GetSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Segment>> {
        const requestOptions = await this.getSegmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SegmentFromJSON(jsonValue));
    }

    /**
     */
    async getSegment(requestParameters: GetSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Segment> {
        const response = await this.getSegmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStatusLogs without sending the request
     */
    async getStatusLogsRequestOpts(requestParameters: GetStatusLogsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getStatusLogs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/status-logs`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getStatusLogsRaw(requestParameters: GetStatusLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SegmentStatusLog>>> {
        const requestOptions = await this.getStatusLogsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SegmentStatusLogFromJSON));
    }

    /**
     */
    async getStatusLogs(requestParameters: GetStatusLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SegmentStatusLog>> {
        const response = await this.getStatusLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateSegment without sending the request
     */
    async updateSegmentRequestOpts(requestParameters: UpdateSegmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSegment().'
            );
        }

        if (requestParameters['segment'] == null) {
            throw new runtime.RequiredError(
                'segment',
                'Required parameter "segment" was null or undefined when calling updateSegment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SegmentToJSON(requestParameters['segment']),
        };
    }

    /**
     */
    async updateSegmentRaw(requestParameters: UpdateSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Segment>> {
        const requestOptions = await this.updateSegmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SegmentFromJSON(jsonValue));
    }

    /**
     */
    async updateSegment(requestParameters: UpdateSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Segment> {
        const response = await this.updateSegmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateStatus without sending the request
     */
    async updateStatusRequestOpts(requestParameters: UpdateStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateStatus().'
            );
        }

        if (requestParameters['statusRequest'] == null) {
            throw new runtime.RequiredError(
                'statusRequest',
                'Required parameter "statusRequest" was null or undefined when calling updateStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/status`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StatusRequestToJSON(requestParameters['statusRequest']),
        };
    }

    /**
     */
    async updateStatusRaw(requestParameters: UpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Segment>> {
        const requestOptions = await this.updateStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SegmentFromJSON(jsonValue));
    }

    /**
     */
    async updateStatus(requestParameters: UpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Segment> {
        const response = await this.updateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
